'use client';

import React from 'react';

interface StickyCard {
  title: string;
  description: string;
}

interface StickyScrollSectionProps {
  title: string;
  cards: StickyCard[];
  backgroundColor?: string;
}

const StickyScrollSection: React.FC<StickyScrollSectionProps> = ({
  title,
  cards,
  backgroundColor = 'bg-default-100',
}) => {
  return (
    <section className={`${backgroundColor} relative`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
          {/* Left side - Sticky title */}
          <div className="lg:py-24">
            <div className="lg:sticky lg:top-40 lg:pt-8">
              <h2 className="rh-lg mb-4">{title}</h2>
            </div>
          </div>

          {/* Right side - Scrolling cards */}
          <div className="space-y-8 py-16 lg:py-24">
            {cards.map((card, index) => (
              <div
                key={index}
                className="bg-white p-6 sm:p-8 rounded-2xl border border-default-200"
              >
                <h4 className="!pb-0 mb-3 font-selawik font-medium text-lg sm:text-xl">
                  {card.title}
                </h4>
                <p
                  className="text-default-700 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: card.description }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StickyScrollSection;
